import { Component, OnInit } from '@angular/core';
import { EcaBreadcrumbService } from '../../services/eca-breadcrumb.service';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-eca-breadcrumb',
  templateUrl: './eca-breadcrumb.component.html',
  styleUrls: ['./eca-breadcrumb.component.scss']
})

export class EcaBreadcrumbComponent implements OnInit {
  showDashboardCrumb: boolean = true;
  private ecaBreadcrumb: MenuItem[] = [];
  ecaBreadcrumbHome: MenuItem;
  
  constructor(private ecaBreadcrumbService: EcaBreadcrumbService,
    private router: Router) {
  }

  ngOnInit(): void {
    //Set home breadcrumb
    this.ecaBreadcrumbHome = {
      label: 'Dashboard',
      icon: 'fa-solid fa-gauge-high',
      routerLink: ['dashboard'],
    };

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.ecaBreadcrumb = [];
      }
    });

    this.ecaBreadcrumbService.breadCrumbs.asObservable().subscribe(ecaBreadcrumbs => {
      this.ecaBreadcrumb = [];
      ecaBreadcrumbs.forEach(breadcrumb => {
        if (breadcrumb?.label && breadcrumb.label !== "HideDashboard") {
          let newBreadcrumbItem: MenuItem;
          newBreadcrumbItem = {
            label: breadcrumb?.label,
            icon: 'fad fa-' + breadcrumb?.iconName,
            visible: true,
            routerLink: breadcrumb?.routeLink,
          };
          this.ecaBreadcrumb.push(newBreadcrumbItem);
          console.log(this.ecaBreadcrumb);
        }
        else if (breadcrumb.label === "HideDashboard") {
          this.showDashboardCrumb = false;
        }
      });
    });
  }
}

